









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryIncomeFileList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import { InvestorIncomeFileStatusFormat } from '@/utils/tyepconvert'
import ImportInvestorIncomeDialog from './ImportInvestorIncomeDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    ImportInvestorIncomeDialog,
  },
})
export default class MedicineCabinetList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '年月', param: 'name' },
    // { title: '药柜状态', param: 'status', type: 'select', selectData: constant.MedicineCabinetStatus},
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    // { title: '新增药柜', type: 'primary', click: this.openCreateVideo },
    { title: '上传报表', type: 'primary', click: this.openImport },
  ]
  // 数据表头 - 
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '年月', param: 'month' },
    { title: '状态', param: 'state', formatter: InvestorIncomeFileStatusFormat},
    { title: '最近更新时间', param: 'updateTime', formatter: DateFormat },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    //  {
    //   title: '操作',
    //   operation: [
    //     { title: '上传报表', click: this.openImport },
    //   ],
    // },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo(){
    console.log('s')
  }
  private openImport(){
    const d = this.$refs.ImportInvestorIncomeDialog as ImportInvestorIncomeDialog
    d.open()
  }
  private openChangeStatus(data: any){
    console.log('s')
  }
  
  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      // const ruslt = await VideoDelte({ id: data.id })
      // if (ruslt) {
      //   Message.success('删除成功')
      //   this.loadData()
      // }
    })
  }

  public openEditVideo(data: any){
    console.log('s')
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryIncomeFileList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
  
}
